import { defineStore } from "pinia";
import { ref } from "vue";

export const useOnboardingStore = defineStore("onboarding", () => {
    const isOnboarding = ref(false)
    const onboardingStep = ref(null)
    const openedCoverLetter = ref(null)

    const markAsOnboarding = (mode) => {
        return isOnboarding.value = mode
    }

    const setCurrentStep = (step) => {
        return onboardingStep.value = step
    }

    const setOpenedCoverLetter = mode => {
        openedCoverLetter.value = mode
    }

    return {
        openedCoverLetter,
        setOpenedCoverLetter,
        markAsOnboarding,
        isOnboarding,
        setCurrentStep,
        onboardingStep
    };
});
